import KanbanBoard from "../../ReusableComponents/KanbanBoard";

const COLUMN_META = [
  { title: "To Do", status: "To Do", underline: "#38a4f8" },
  { title: "In progress", status: "In progress", underline: "#ffb829" },
  { title: "Admin Approval", status: "Admin Approval", underline: "#f5325c" },
  {
    title: "Customer Approval",
    status: "Customer Approval",
    underline: "#2c587e",
  },
  { title: "Done", status: "Done", underline: "#0abb87" },
];

const KanbanPageTask = ({ tasks, setTasks, onTaskClick }) => {
  return (
    <KanbanBoard
      columnsMeta={COLUMN_META}
      items={tasks}
      setItems={setTasks}
      onItemClick={onTaskClick}
    />
  );
};

export default KanbanPageTask;
